import { GetMyUpcomingReservationsResponseDto } from "@/api/generated/generatedTypes";
import { getReservationStatusInfo } from "@/utils/reservationStatusHelper";
import { Text } from "@mantine/core";

interface ReservationStatusLabelResolverProps {
  reservation: GetMyUpcomingReservationsResponseDto;
  isPast: boolean;
}

export const ReservationStatusLabelResolver = ({
  reservation,
  isPast,
}: ReservationStatusLabelResolverProps) => {
  const { label, color } = getReservationStatusInfo({
    status: reservation.status,
    cancellationCategory: reservation.cancellationCategory,
    isPast,
  });

  return (
    <Text p="md" c={color}>
      {label}
    </Text>
  );
};
